import config from "../../staticConfig";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { TypeNoteHistoryItem, TypeCallerInfor } from "../../types/TypeContact";

export const addNoteAction = async (
  noteObject: TypeNoteHistoryItem,
  callerData: TypeCallerInfor
): Promise<number> => {
  try {
    const endpointUrl = `${config.apiGatewayEndpoint}/addnote`;
    const urlParams = new URL(window.location.href).searchParams;
    const agentId = urlParams.get("agentId")!;

    const contact = {
      ...noteObject,
      pk: uuid(),
      sk: `${noteObject.timestamp}|${agentId}`,
      company: callerData.company,
      agentId: agentId,
      customerName: callerData.customerName,
    };
    const response = await axios.post(endpointUrl, { data: contact });
    return response.status;
  } catch (error) {
    console.error(error);
    return 500;
  }
};
